import React from 'react';
import PropTypes from 'prop-types';
import BasicCheckbox from 'components/BasicCheckbox';
import LinkButton from 'components/LinkButton';

import './styles.css';

const InputFileRow = props => {
  const { file, onRemoveHandler, onChangeHandler } = props;
  const { FileName, DateUpload, Show, Link, Deleted = '0' } = file;

  const handleRemove = () => {
    if (typeof onRemoveHandler === 'function') {
      onRemoveHandler(file);
    }
  };

  const handleShowToFirm = () => {
    if (typeof onChangeHandler === 'function') {
      onChangeHandler(file);
    }
  };

  return (
    <div className="input-file-table-row">
      <div className="input-file-table-row__fields">
        <div className="input-file-table-row__field">
          <div className="input-file-table-row__block">
            <div className="input-file-table-row__name">File Name</div>
            <LinkButton link={Link} text={FileName} underline={false} />
          </div>
        </div>

        <div className="input-file-table-row__field input-file-table-row__field--date">
          <div className="input-file-table-row__block">
            <div className="input-file-table-row__name">Uploaded on:</div>
            <div className="input-file-table-row__value">{DateUpload}</div>
          </div>
        </div>

        <div className="input-file-table-row__field input-file-table-row__field--controls">
          <div className="input-file-table-row__control">
            <BasicCheckbox
              value={Show}
              singleRow
              checked={Show === '1'}
              title="Show to Firms"
              name="Show to Firms"
              wrapperStyles={{ height: 'auto' }}
              controlFunc={handleShowToFirm}
              labelStyles={{
                fontFamily: 'Noto Sans, sans-serif',
                fontSize: '0.9286rem',
                margin: '5px 0',
              }}
            />
          </div>

          <div className="input-file-table-row__control">
            <BasicCheckbox
              value={Deleted}
              singleRow
              checked={Deleted === '1'}
              wrapperStyles={{ height: 'auto' }}
              title="Delete"
              name="Delete File"
              controlFunc={handleRemove}
              labelStyles={{
                fontFamily: 'Noto Sans, sans-serif',
                fontSize: '0.9286rem',
                margin: '5px 0',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

InputFileRow.propTypes = {
  file: PropTypes.object.isRequired,
  onRemoveHandler: PropTypes.func,
  onChangeHandler: PropTypes.func,
};

export default InputFileRow;
